import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames/bind';
import { Widget } from '@creditsights/styleguide-web';
import { ROUTES } from '../../../Base.constants';
import { Region } from '../../../models';
import { useFetchMorningCommentaries } from '../../../hooks/articles';
import { WIDGET_ID } from '../../../pages/Article/Article.constants';
import { formatDate } from '../../../utils/dateUtils';

import styles from './MorningCommentLinkWidget.module.scss';

const cx = classNames.bind(styles);
const COMMENT_COUNT = 5;

interface MorningCommentWidgetProps {
  region: Region;
}

const regionTitleMap = {
  [Region.UnitedStates]: 'US Morning Comment',
  [Region.Europe]: 'EU Morning Comment',
};

const MorningCommentLinkWidget = ({ region }: MorningCommentWidgetProps): React.ReactElement => {
  const { data: articles = [], isLoading } = useFetchMorningCommentaries(region, COMMENT_COUNT);

  return (
    <Widget
      headerTitle={regionTitleMap[region]}
      isLoading={isLoading}
      wrapFirstLine
      fixedHeight
      dataTestId={WIDGET_ID.MORNING_COMMENT_LINK}
    >
      <div className={cx('body')}>
        {articles.map((article) => (
          <Link
            key={article.id}
            to={ROUTES.article(article.id)}
            className={cx('link')}
            data-testid="morning-comment-link"
          >
            {formatDate(article.publishDate)}
          </Link>
        ))}
      </div>
    </Widget>
  );
};

export default MorningCommentLinkWidget;
